import BudgetBanner from "@src/components/home/budgetBanner/BudgetBanner";
import { lazy } from "react";

const BudgetType = lazy(() => import("../pages/budget/BudgetType"));
const BudgetSetting = lazy(() => import("../pages/budget/BudgetSetting"));
const BudgetHome =  lazy(() => import("../pages/budget/BudgetHome"));
const BudgetSampleList = lazy(() => import("../pages/budget/BudgetSampleList"));
const BudgetWrite = lazy(() => import("../pages/budget/BudgetWrite"));
const BudgetDetail = lazy(() => import("../pages/budget/BudgetDetail"));
const BudgetHistory = lazy(() => import("../pages/budget/BudgetHistory"));
const BudgetUpcoming = lazy(() => import("../pages/budget/BudgetUpcoming"));

export const budgetRoutes = [
  { path: "/budget/type", element: <BudgetType /> },
  { path: "/budget/setting", element: <BudgetSetting /> },
  { path: "/budget/home", element: <BudgetHome /> },
  { path: "/budget/sample", element: <BudgetSampleList /> },
  { path: "/budget/write", element: <BudgetWrite /> },
  { path: "/budget/detail", element: <BudgetDetail /> },
  { path: "/budget/history/:category", element: <BudgetHistory /> },
  { path: "/budget/upcoming", element: <BudgetUpcoming /> },
  { path: "/budget/banner", element: <BudgetBanner /> },
];